<template>
	<c-dialog ref="dialog" width="600" @resolve="editHandle">
		<c-form ref="form" vertical unit-width="100%">
			<c-input type="hidden" name="id"></c-input>
			<c-form-item label="任务类型名称" required>
				<c-input name="type_name" maxlength="10"></c-input>
			</c-form-item>
			<c-form-item label="颜色标记">
				<div class="color-board">
					<span
						v-for="item in colorList"
						:key="item"
						class="color-item"
						:class="{active: color == item}"
						:style="{background: item}"
						@click="color = item"
					></span>
				</div>
			</c-form-item>
			<c-form-item label="标题规则" label-tip="创建任务时按已选字段顺序自动生成任务标题，字段间用-分隔">
				<c-select name="title_rule" multiple :options="titleRuleOptions"></c-select>
			</c-form-item>
			<c-form-item label="负责人范围-人员" label-tip="人员和部门都不选择，则所有人都可被指派为负责人">
				<c-select name="user_ids" async multiple @search="searchUser" :value-data="selectedUser" @change="scopeChangeHandle"></c-select>
			</c-form-item>
			<c-form-item label="负责人范围-部门" label-tip="人员和部门都不选择，则所有人都可被指派为负责人">
				<c-select name="dept_ids" async multiple @search="searchDepartment" :value-data="selectedDepartment" @change="scopeChangeHandle"></c-select>
			</c-form-item>
			<c-form-item label="默认负责人" label-tip="创建任务时自动填充的负责人，候选限负责人范围内">
				<c-select ref="defaultUser" name="default_user_id" async @search="searchScopeUser" :value-data="selectedDefaultUser"></c-select>
			</c-form-item>
		</c-form>
	</c-dialog>
</template>

<script>
//标题规则候选字段
export const TITLE_RULE_OPTIONS = [
	{name: '任务类型名称', value: 'type_name'},
	{name: '负责人', value: 'user_realname'},
	{name: '创建人', value: 'create_user_realname'},
	{name: '创建日期', value: 'create_date'}
];
//16色色板
const COLOR_LIST = [
	'#999999', '#0D6EFE', '#F56C6C', '#2EBC78', '#FFAE00', '#FF5400', '#7353E9'
];

export default {
	data() {
		return {
			color: COLOR_LIST[0],
			colorList: COLOR_LIST,
			titleRuleOptions: TITLE_RULE_OPTIONS,
			selectedUser: [],
			selectedDepartment: [],
			selectedDefaultUser: []
		}
	},

	methods: {
		/*********打开编辑框，初始化**********/
		open(data) {
			this._editState = !!data;
			this.color = COLOR_LIST[0];
			this.selectedUser = [];
			this.selectedDepartment = [];
			this.selectedDefaultUser = [];

			this.$refs.form.clear();
			if (data) {
				//查询任务类型详情
				this.request({
					url: '/collab/task/type/detail',
					data: {
						id: data.id
					},
					success: data => {
						let detailInfo = data.detailInfo || {};
						this.$refs.form.set({
							id: detailInfo.id,
							type_name: detailInfo.type_name,
							default_user_id: detailInfo.default_user_id
						});
						this.color = detailInfo.color || COLOR_LIST[8];

						//标题规则回显
						if (detailInfo.title_rule) {
							try {
								this.$refs.form.set({title_rule: detailInfo.title_rule || []});
							} catch (e) {}
						}
						//负责人范围回显
						let scope = {};
						try {
							scope = detailInfo.user_scope_json || {};
						} catch (e) {}
						if (data.scopeUserList) {
							this.selectedUser = data.scopeUserList.map(item => {
								return {
									name: item.user_realname,
									value: item.id
								}
							});
						}
						if (data.scopeDeptList) {
							this.selectedDepartment = data.scopeDeptList.map(item => {
								return {
									name: item.department_name,
									value: item.id
								}
							});
						}
						this.$refs.form.set({
							user_ids: scope.user_ids || [],
							dept_ids: scope.dept_ids || []
						});
						//默认负责人回显
						if (detailInfo.default_user_id) {
							this.selectedDefaultUser = [{
								name: detailInfo.default_user_realname,
								value: detailInfo.default_user_id
							}];
						}
					}
				});
			}
			//填充form表单
			this.$refs.dialog.open({
				title: data ? '编辑任务类型' : '创建任务类型'
			});
		},

		/*******搜索用户*****************/
		searchUser(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'SYSUSER',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索部门*****************/
		searchDepartment(keyword, resolve){
			this.request({
				url:'/system/options',
				data: {
					options_code:'DEPARTMENT',
					keyword: keyword
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******搜索默认负责人（限当前已选负责人范围内）*****************/
		searchScopeUser(keyword, resolve){
			let formData = this.$refs.form.get();
			this.request({
				url:'/collab/task/type/scope/users',
				data: {
					keyword: keyword,
					user_ids: formData.user_ids || [],
					dept_ids: formData.dept_ids || []
				},
				success:data => {
					resolve(data);
				}
			})
		},

		/*******负责人范围（人员/部门）变更，重置默认负责人*****************/
		scopeChangeHandle(){
			this.selectedDefaultUser = [];
			this.$refs.defaultUser.set('');
		},

		/*******创建、编辑提交处理方法********/
		editHandle (stop, next){
			stop();
			this.$refs.form.submit({
				url: this._editState?'/collab/task/type/edit':'/collab/task/type/add',
				rule: {
					type_name: '请输入任务类型名称'
				},
				dataFormatter: data => {
					data.color = this.color;
					//标题规则（JSON数组存有序字段码）
					data.title_rule = data.title_rule && data.title_rule.length ? JSON.stringify(data.title_rule) : '';
					//负责人范围
					data.user_scope_json = JSON.stringify({
						user_ids: data.user_ids || [],
						dept_ids: data.dept_ids || []
					});
					delete data.user_ids;
					delete data.dept_ids;
					return data;
				},
				success: (data, res) => {
					next();
					this.$message({
						message: '提交成功',  // 提示内容,
						type: 'success'
					});
					this.$emit('resolve');
				}
			});
		}
	}
}
</script>

<style lang="stylus" scoped>
	.color-board {
		display: flex;
		flex-wrap: wrap;

		.color-item {
			width: 22px;
			height: 22px;
			margin: 0 8px 8px 0;
			border-radius: 50%;
			cursor: pointer;
			box-sizing: border-box;

			&.active {
				border: 2px solid #fff;
				box-shadow: 0 0 0 2px var(--color-main);
			}
		}
	}
</style>
